const ROLES = {
  reviewManager: 'admin, view, edit',
  staff: 'view, edit',
  default: 'view',
};

export default ROLES;
